// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"4122fdcb","118":"e6d18df4","245":"5539bc90","342":"0d634dd6","411":"7edd1e0a","546":"aa760413","574":"efcd5b7e","628":"c3452814","761":"e0fb56fe"}[chunkId] + ".chunk.js";
};